export default {"src":"/_next/static/media/gelato.8b75f482.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};